import { ByggMenuItems } from '@klp/bygg/config';
import { ClientMenuItems } from '@klp/client/config';
import { ContractManagementMenuItems } from '@klp/contractmanagement';
import { AppMenuItems } from '@klp/core/app/config';
import { FakturaMenuItems } from '@klp/faktura/config';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { SwedishErrorReportingMenuItems } from '@klp/layout/Sidebar/config';
import { MessageBoardMenuItems } from '@klp/messageboard/config';
import { ProjectDxboMenuItems } from '@klp/projectdxbo/config';
import { SakMenuItems } from '@klp/sak/config';
import { SupportFormMenuItems } from '@klp/supportapplicationform/config';
import { SustainabilityMenuItems } from '@klp/sustainability/config';
import { UserMenuItems } from '@klp/user/config';

export const menuItems = [
    ...AppMenuItems,
    ...MessageBoardMenuItems,
    ...ByggMenuItems,
    ...ContractManagementMenuItems,
    ...FakturaMenuItems,
    ...ProjectDxboMenuItems,
    ...SakMenuItems,
    ...SwedishErrorReportingMenuItems,
    ...SupportFormMenuItems,
];

export const secondaryMenuItems = [
    new SidebarMenuItem({
        divider: true,
        condition: (props: any) =>
            props.params.isAdmin ||
            (!props.params.isAdmin && props.clients.length > 1),
    }),

    ...ClientMenuItems,
    ...UserMenuItems,
];

export const sustainabilityMenuItems = [...SustainabilityMenuItems];
